import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CheckFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.4019 22C17.8729 22 22.4062 17.4734 22.4062 12C22.4062 6.52659 17.8642 2 12.3932 2C6.92695 2 2.40625 6.52659 2.40625 12C2.40625 17.4734 6.93566 22 12.4019 22ZM11.311 16.8095C11.0098 16.8095 10.7726 16.6932 10.5401 16.3871L9.2492 14.8185L7.95828 13.2499C7.82074 13.0823 7.74807 12.8846 7.74807 12.6869C7.74807 12.2867 8.0484 11.9679 8.44928 11.9679C8.69826 11.9679 8.89588 12.0494 9.10307 12.3342L11.2723 15.0555L15.6615 8.06776C15.8203 7.80037 16.048 7.66277 16.2804 7.66277C16.6678 7.66277 17.0165 7.92447 17.0165 8.33427C17.0165 8.52415 16.9129 8.73054 16.8006 8.89909L12.0383 16.3871C11.8494 16.6719 11.6035 16.8095 11.311 16.8095Z"
        fill={color}
      />
      <path
        d="M10.542 16.3884C10.7745 16.6945 11.0117 16.8108 11.3129 16.8108C11.6054 16.8108 11.8514 16.6732 12.0403 16.3884L16.8025 8.90038C16.9148 8.73184 17.0184 8.52544 17.0184 8.33556C17.0184 7.92576 16.6697 7.66406 16.2824 7.66406C16.0499 7.66406 15.8223 7.80166 15.6634 8.06905L11.2742 15.0568L9.105 12.3355C8.89781 12.0506 8.70018 11.9692 8.45121 11.9692C8.05033 11.9692 7.75 12.288 7.75 12.6882C7.75 12.8859 7.82267 13.0836 7.96021 13.2512L9.25113 14.8198L10.542 16.3884Z"
        fill="white"
      />
    </svg>
  );
};

export { CheckFilledSvg };
